export default __webpack_public_path__ + "media/partner.600be0c2.png";